import { useState, useContext, useEffect } from 'react'
import { getAuth, updateProfile } from 'firebase/auth'
import { setDoc, doc, collection, query, getDocs, where, deleteDoc } from 'firebase/firestore'
import { db } from '../firebase.config'
import { useNavigate } from 'react-router-dom'
import LoadingContext from '../contexts/loading/LoadingContext' 
import ListingItem from '../components/listings/ListingItem'
import FadeSpinner from '../components/feedback/FadeSpinner'
import UserContext from '../contexts/user/UserContext'
import { Helmet } from 'react-helmet'

import {
  Button,
  Heading,
  Input,
  Flex,
  Box,
  Spacer,
  useToast
} from '@chakra-ui/react'


import {  
  CheckIcon,
  EditIcon,
} from '@chakra-ui/icons'

import UserPosts from '../components/userPosts/UserPosts'

const Profile = () => {

  const navigate = useNavigate()
  const auth = getAuth()
  const toast = useToast()
  
  const [isEditing, setIsEditing] = useState(false)

  const [formData, setFormData] = useState({
    name: auth.currentUser.displayName,
    email: auth.currentUser.email,
  })
  const { name, email } = formData

  const [listings, setListings] = useState(null)

  const { spinnerLoading, buttonLoading, dispatch } = useContext(LoadingContext)
  const { dispatch: setUserState } = useContext(UserContext)


  useEffect(() => {

    const fetchUserListings = async () => {
      const listingRef = collection(db, 'properties')

      const q = query(
        listingRef,
        where('userRef', '==', auth.currentUser.uid),
      )

      const querySnap = await getDocs(q)
      let listings = []
      querySnap.forEach(doc => {
        return listings.push({
          id: doc.id,
          data: doc.data()
        })
      })

      setListings(listings)
      dispatch({ type: 'STOP_SPINNER_LOADING' })
    }

    fetchUserListings()
  }, [auth.currentUser.uid])

  const submitHandler = async (e) => {

    dispatch({ type: 'START_LOADING' })
    try {
      if (name !== auth.currentUser.displayName) {
        await updateProfile(auth.currentUser, {
          displayName: name
        })
        const userRef = doc(db, 'users', auth.currentUser.uid)
        await setDoc(userRef, {
          name,
          email
        })
      }
      console.log('success')
      toast({
        title: 'Edited successfully',
        description: "We've edited yout info",
        position: 'top',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      dispatch({ type: 'STOP_LOADING' })
      setUserState({ type: 'SET_USER', payload: name})

    } catch (error) {
      console.log(error.code)
      toast({
        title: 'Something went wrong!',
        description: "Please try later",
        position: 'top',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      dispatch({ type: 'STOP_LOADING' })
    }
    
  }
  
  const changeHandler = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }))
  }
  const signoutHandler = () => {
    auth.signOut()
    navigate('/sign-in')
  }

  const deleteListing = async (listingId) => {
    if (window.confirm('Are you sure')) {
      await deleteDoc(doc(db, 'properties', listingId))
      const updatedListings = listings.filter(listing => listing.id !== listingId)
      setListings(updatedListings)
      toast({
        title: 'Success',
        description: "Deleted",
        position: 'top',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    }
  }
  return (
    <>
     <Helmet>
        <title>
          Profile | EstateGhar
        </title>
        <meta
          name="description"
          content={`See your profile on EstateGhar`}
        />
          <meta
          name="keywords"
          content="property for sale in pakistan, properties for sale in pakistan, houses for sale in pakistan, house for sale in pakistan, plots for sale in pakistan, residential plots for sale in pakistan, commercial plots for sale in pakistan, apartments for sale in pakistan, flats for sale in pakistan, villas for sale in pakistan, shops for sale in pakistan, commercial property for sale in pakistan, land for sale in pakistan, farm house for sale in pakistan, real estate pakistan, property dealers in pakistan, property investment in pakistan, cheap houses for sale in pakistan, luxury houses for sale in pakistan, property in pakistan for sale, property for rent in pakistan, houses for rent in pakistan, house for rent in pakistan, flats for rent in pakistan, apartments for rent in pakistan, shops for rent in pakistan, offices for rent in pakistan, commercial property for rent in pakistan, rooms for rent in pakistan, hostel for rent in pakistan, warehouse for rent in pakistan, portion for rent in pakistan, upper portion for rent in pakistan, lower portion for rent in pakistan, furnished apartment for rent in pakistan, rental property in pakistan, property on rent in pakistan, property for sale in karachi, houses for sale in karachi, flats for sale in karachi, plots for sale in karachi, apartments for sale in karachi, property for rent in karachi, houses for rent in karachi, flats for rent in karachi, property for sale in lahore, houses for sale in lahore, plots for sale in lahore, apartments for sale in lahore, DHA lahore houses for sale, bahria town lahore houses for sale, property for rent in lahore, houses for rent in lahore, flats for rent in lahore, property for sale in islamabad, houses for sale in islamabad, plots for sale in islamabad, apartments for sale in islamabad, DHA islamabad property for sale, bahria town islamabad property for sale, property for rent in islamabad, houses for rent in islamabad, flats for rent in islamabad, property for sale in rawalpindi, houses for sale in rawalpindi, plots for sale in rawalpindi, property for rent in rawalpindi, property for sale in peshawar, houses for sale in peshawar, plots for sale in peshawar, property for rent in peshawar, property for sale in swat, houses for sale in swat, plots for sale in swat, land for sale in swat, commercial property for sale in swat, property for rent in swat, houses for rent in swat, shops for rent in swat, property for sale in multan, houses for sale in multan, plots for sale in multan, property for rent in multan, property for sale in faisalabad, houses for sale in faisalabad, plots for sale in faisalabad, property for rent in faisalabad, property for sale in quetta, houses for sale in quetta, plots for sale in quetta, property for rent in quetta, property for sale in hyderabad pakistan, houses for sale in hyderabad pakistan, plots for sale in hyderabad pakistan, property for rent in hyderabad pakistan, property for sale in gujranwala, houses for sale in gujranwala, plots for sale in gujranwala, property for rent in gujranwala, property for sale in sialkot, houses for sale in sialkot, plots for sale in sialkot, property for rent in sialkot, property for sale in abbottabad, houses for sale in abbottabad, plots for sale in abbottabad, property for rent in abbottabad, property for sale in murree, houses for sale in murree, cottages for sale in murree, apartments for rent in murree, guest house for rent in murree, farmhouse for rent in pakistan, wedding lawn for rent in pakistan, plaza for sale in pakistan, plaza for rent in pakistan, building for sale in pakistan, building for rent in pakistan, office space for rent in pakistan, co working space in pakistan, real estate agents in pakistan, property dealers near me, zameen property pakistan, olx property pakistan, urgent house for sale in pakistan, installment plots in pakistan, easy installment houses in pakistan, overseas pakistanis property investment, pakistan real estate market, buy property in pakistan, sell property in pakistan, rent property in pakistan"
        />
      </Helmet>
    <div className='container p-9'>
      <Flex className='mb-4'>
        <Box>
        <div className="text-4xl text-center my-10  text-gray-800">My Info</div>
        </Box>
        <Spacer />
        <Box>
          <Button
            className='mx-1'
            variant={isEditing ? 'outline' : 'solid'}
            isLoading = {buttonLoading}
            onClick={() => {
              isEditing && submitHandler()
              setIsEditing(prev => !prev)
            }}  
            colorScheme='teal' 
            size='sm'
            loadingText='Editing ..'
          >
              {isEditing ? 'Save' : 'Edit'}
              {isEditing ? <CheckIcon className='ml-2' /> : <EditIcon className='ml-2' /> }
              
          </Button>
          <Button 
            className='mx-1'
            onClick={() => signoutHandler()}
            variant='outline'
            colorScheme='teal' 
            size='sm'
          >
            Sign out
          </Button>
        </Box>
      </Flex>
      
     
      <Input className='mt-3' id='name' value={name} onChange={changeHandler} disabled={!isEditing} />
      <Input className='mt-3' id='email' value={email} onChange={changeHandler} disabled />

      <h1 className="text-4xl text-center my-5  text-gray-800">My Advertisments</h1>
      { spinnerLoading && <FadeSpinner  /> }
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      {
        listings?.length > 0 && 
        <>
          {listings.map(listing => (
            <ListingItem 
              id={listing.id}
              key={listing.id}
              property={listing.data}
              deleteListing={() => deleteListing(listing.id)}
              editListing
            />
          ))}
        </>
      }
      </div>

    </div>
    <UserPosts />
    </>
    
  )
}

export default Profile